import {
    Component,
    EventEmitter,
    forwardRef,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ChangeDetectionStrategy
} from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { Observable } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ControlValueAccessorBaseComponent } from "../base-component/control-value-accessor-base.component";
import { RequiredDirective } from "../../directives/required/required.directive";
import { InfoComponent } from "../info/info.component";
import { CheckboxItemComponent } from "./checkbox-item/checkbox-item.component";
import { ValidationMessageComponent } from "../../validation/validation-message/validation-message.component";

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxListComponent)
        }
    ],
    selector: "rask-checkbox-list",
    templateUrl: "./checkbox-list.component.html",
    styleUrls: ["./checkbox-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RequiredDirective,
        InfoComponent,
        CheckboxItemComponent,
        ValidationMessageComponent
    ]
})
export class CheckboxListComponent extends ControlValueAccessorBaseComponent implements OnInit, OnChanges {

  @Input() label: string;
  @Input() items: Observable<string[]>;
  @Input() selected: any[];
  @Output() checkedChange = new EventEmitter();
  checkboxItems = [];

  changed(key: any[]): void {
      let selections = JSON.parse(JSON.stringify(this.value));
      if (key[1] === false) {
          selections = selections.filter(e => e !== key[0]);
      } else {
          selections.push(key[0]);
      }
      this.value = selections;
  }

  ngOnInit() {
      this.required = this.required !== true ? false : true;
      super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges) {
      if (changes.items !== undefined && changes.items.currentValue !== undefined) {
          changes.items.currentValue.pipe(
              takeUntil(this.destroy$)
          ).subscribe((res: any[]) => {
              this.checkboxItems = res.map(x => this.getModel(x));
          });
      }
      this.checkboxItems.forEach(item => {
          item.value = this.isSelected(item.text);
      });
  }

  private getModel(text: string) {
      return { text: text,
          value: this.isSelected(text) };
  }

  private isSelected(text: string) {
      const selected = this.selected.find(x => x === text);
      return selected !== undefined ? true : false;
  }
}
